/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/SubscriptionDetails/theme';

export const SubscriptionDetailsTheme = theme;
